import { apiClient, getToken, getOrgId } from '@devd-client/api';

export const getMetricsList = (): Promise<any> =>
  apiClient(`/v1/config/metric/org/${getOrgId()}?type=metric`, {
    method: 'GET',
    headers: {
      authorization: `bearer ${getToken()}`,
    },
  });

export const getTeamMetricsList = (teamName: any): Promise<any> =>
  apiClient(
    `/v1/config/metric/org/${getOrgId()}?type=metric&team=${teamName}`,
    {
      method: 'GET',
      headers: {
        authorization: `bearer ${getToken()}`,
      },
    }
  );

export const updateCustomDashboard = (params: any): Promise<any> =>
  apiClient(`/v1/custom-dashboard/${getOrgId()}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      authorization: `bearer ${getToken()}`,
    },
    body: JSON.stringify(params),
  });
